// redux/reducer/refreshSlice.ts
import { createSlice } from '@reduxjs/toolkit';

const notificationRefreshSlice = createSlice({
  name: 'refresh',
  initialState: {
    refreshNotifications: false,
  },
  reducers: {
    triggerNotificationRefresh: (state) => {
      state.refreshNotifications = true;
    },
    resetNotificationRefresh: (state) => {
      state.refreshNotifications = false;
    },
  },
});

export const {
  triggerNotificationRefresh,
  resetNotificationRefresh,
} = notificationRefreshSlice.actions;

export default notificationRefreshSlice.reducer;
